import PropTypes from 'prop-types';
import { useEffect, Fragment } from 'react';
import UITour from 'ui-shepherd-react/tour/UITour';
import { loadOnboardingTourBanner } from 'onboarding-tours/util/banner';
import PickersContext from 'ContentComponents/context/PickersContext';
// @ts-expect-error not migrated yet
import { pickerComponents } from './PickerComponents';
import { useTourConfig } from './onboarding/OnboardingTour';
import { jsx as _jsx } from "react/jsx-runtime";
const RootTreeWrapper = ({
  children
}) => {
  useEffect(() => {
    loadOnboardingTourBanner();
  }, []);
  const {
    tourKey,
    config
  } = useTourConfig();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(PickersContext.Provider, {
      value: pickerComponents,
      children: /*#__PURE__*/_jsx(UITour, {
        activateOnMount: false,
        tour: tourKey,
        config: config,
        children: children
      })
    })
  });
};
RootTreeWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
export default RootTreeWrapper;